import type { CSSProperties } from 'react';
import type { ShellPresentation } from '../types/fieldMapping';

export function buildShellPresentation(source: {
  className?: string;
  style?: Record<string, string | number>;
}): ShellPresentation | undefined {
  const className = source.className?.trim();
  const style = source.style;
  const hasClassName = className != null && className.length > 0;
  const hasStyle = style != null && Object.keys(style).length > 0;

  if (!hasClassName && !hasStyle) return undefined;

  return {
    ...(hasClassName && { className }),
    ...(hasStyle && { style }),
  };
}

export interface MatrixFieldShellPresentationInput {
  shellPresentation?: ShellPresentation;
  alignStyle?: CSSProperties;
  debugStyle?: CSSProperties;
  debugClassName?: string;
  skipPresentation?: boolean;
}

/**
 * Merge orch shell presentation with internal alignment and Studio debug overlays.
 * Order: orch style → internal align (wins alignSelf) → debug style.
 */
export function mergeMatrixFieldShellPresentation({
  shellPresentation,
  alignStyle,
  debugStyle,
  debugClassName,
  skipPresentation,
}: MatrixFieldShellPresentationInput): { style?: CSSProperties; className?: string } {
  const shellStyle = skipPresentation ? undefined : shellPresentation?.style;
  const mergedStyle =
    shellStyle || alignStyle || debugStyle
      ? {
          ...(shellStyle as CSSProperties | undefined),
          ...alignStyle,
          ...debugStyle,
        }
      : undefined;

  const shellClassName = skipPresentation ? undefined : shellPresentation?.className;
  const className = [shellClassName, debugClassName].filter(Boolean).join(' ') || undefined;

  return {
    ...(mergedStyle != null && { style: mergedStyle }),
    ...(className != null && { className }),
  };
}
